interface Props {
  className?: string;
}

export const LockIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        d="M9.5 5H10C10.2761 5 10.5 5.22385 10.5 5.5V10.5C10.5 10.7761 10.2761 11 10 11H2C1.72386 11 1.5 10.7761 1.5 10.5V5.5C1.5 5.22385 1.72386 5 2 5H2.5V4.5C2.5 2.56701 4.06701 1 6 1C7.933 1 9.5 2.56701 9.5 4.5V5ZM8.5 5V4.5C8.5 3.11929 7.3807 2 6 2C4.61929 2 3.5 3.11929 3.5 4.5V5H8.5ZM5.5 7V9H6.5V7H5.5Z"
        fill="white"
      />
    </svg>
  );
};

export const StarIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_2084_12836)">
        <path
          d="M6.00323 9.13L2.4765 11.1041L3.26417 7.13995L0.296875 4.3959L4.31039 3.92003L6.00323 0.25L7.69603 3.92003L11.7095 4.3959L8.74228 7.13995L9.52993 11.1041L6.00323 9.13Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2084_12836">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UserIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        d="M1.99219 11C1.99219 8.79085 3.78305 7 5.99219 7C8.20134 7 9.99219 8.79085 9.99219 11H1.99219ZM5.99219 6.5C4.33469 6.5 2.99219 5.1575 2.99219 3.5C2.99219 1.8425 4.33469 0.5 5.99219 0.5C7.64969 0.5 8.99219 1.8425 8.99219 3.5C8.99219 5.1575 7.64969 6.5 5.99219 6.5Z"
        fill="white"
      />
    </svg>
  );
};

export const ClockIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      className={className}
    >
      <path
        d="M5.0026 9.16634C2.70142 9.16634 0.835938 7.30084 0.835938 4.99967C0.835938 2.69849 2.70142 0.833008 5.0026 0.833008C7.30377 0.833008 9.16927 2.69849 9.16927 4.99967C9.16927 7.30084 7.30377 9.16634 5.0026 9.16634ZM5.41927 4.99967V2.91634H4.58594V5.83301H7.08594V4.99967H5.41927Z"
        fill="white"
      />
    </svg>
  );
};

export const InstantIcon = ({ className }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      className={className}
    >
      <path
        d="M1.3724 1.83496H9.62241C9.87554 1.83496 10.0807 2.04016 10.0807 2.29329V8.70995C10.0807 8.96309 9.87554 9.16828 9.62241 9.16828H1.3724C1.11927 9.16828 0.914062 8.96309 0.914062 8.70995V2.29329C0.914062 2.04016 1.11927 1.83496 1.3724 1.83496ZM2.9745 2.75028H1.82866V3.89612C2.46149 3.89612 2.9745 3.38311 2.9745 2.75028ZM8.01618 2.75028C8.01618 3.38311 8.52919 3.89612 9.16201 3.89612V2.75028H8.01618ZM1.82866 7.10445V8.25029H2.9745C2.9745 7.61746 2.46149 7.10445 1.82866 7.10445ZM8.01618 8.25029H9.16201V7.10445C8.52919 7.10445 8.01618 7.61746 8.01618 8.25029ZM5.49534 7.33362C6.50785 7.33362 7.32868 6.51279 7.32868 5.50028C7.32868 4.48776 6.50785 3.66695 5.49534 3.66695C4.48281 3.66695 3.662 4.48776 3.662 5.50028C3.662 6.51279 4.48281 7.33362 5.49534 7.33362Z"
        fill="white"
      />
    </svg>
  );
};
